import getMediaLibraryAsset from './get-mida-library-asset';

export default {
  getMediaLibraryAsset,
};
